import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { initialState } from './initialState';

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setToken: (state, action: PayloadAction<string | null>) => {
      state.accessToken = action.payload;
    },
    clearToken: (state) => {
      state.accessToken = null;
    },
    setUserDetails: (state, action: PayloadAction<any>) => {
      state.userDetails = action.payload;
    },
    clearUserDetails: (state) => {
      state.userDetails = null;
    },
    setIsFirstAppCreated: (state, action: PayloadAction<boolean>) => {
      if (state.userDetails) {
        state.userDetails.is_first_app_created = action.payload;
      }
    },
    setIsFirstKeyCreated: (state, action: PayloadAction<boolean>) => {
      if (state.userDetails) {
        state.userDetails.is_first_key_created = action.payload;
      }
    },
    setIsFirstParticipantAdded: (state, action: PayloadAction<boolean>) => {
      if (state.userDetails) {
        state.userDetails.is_first_participant_added = action.payload;
      }
    },
    setPlanInfo: (state, action: PayloadAction<any>) => {
      if (state.userDetails) {
        state.userDetails.plan_details = action.payload;
      }
    },
    setActivePlanDetails: (state, action: PayloadAction<any>) => {
      if (state.userDetails) {
        state.userDetails.activePlanDetails = action.payload;
      }
    },
  },
});

export const {
  setToken,
  clearToken,
  setUserDetails,
  clearUserDetails,
  setIsFirstAppCreated,
  setIsFirstKeyCreated,
  setIsFirstParticipantAdded,
  setPlanInfo,
  setActivePlanDetails
} = authSlice.actions;
export default authSlice.reducer;
